import React from "react";
import CommentSection from "../../../../core/CommentSection";

const MessageLog = props => {
  return (
    <CommentSection
      comments={props.content}
      onCommentSubmit={props.onMessageSubmit}
      selectedMessageLogType={props.defaultType}
      messageLogTypes={props.additionalTypes}
      onMessageLogTypeChange={props.onMessageLogTypeChange}
    />
  );
};

export default MessageLog;
